export enum FooterTestIds {
    CONTAINER = 'Footer__container',
    FACEBOOK_ICON = 'Footer__facebook-icon',
    INSTAGRAM_ICON = 'Footer__instagram-icon',
    YOUTUBE_ICON = 'Footer__youtube-icon',
    TWITTER_ICON = 'Footer__twitter-icon',
    TIKTOK_ICON = 'Footer__tiktok-icon',
    OMAZE_LOGO = 'Footer__omaze-logo',
    ACCREDITED_BUSINESS_IMG = 'Footer__acreddited-business-img',
}
